import { useTheme, useMediaQuery } from "@mui/material";

const styles = (isMobile) => ({
  container: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fff",
    fontFamily: "Inter Tight",
  },
  contentWrapper: {
    flex: 1,
    overflow: "auto",
  },
  innerContainer: {
    width: "100%",
    margin: "0 auto",
    padding: isMobile ? "16px" : "24px",
  },
  headerSection: {
    marginBottom: "24px",
  },
  backButton: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    backgroundColor: "#f3f4f6",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    cursor: "pointer",
    marginBottom: "16px",
    "&:hover": {
      backgroundColor: "#e5e7eb",
    },
  },
  header: {
    padding: "4vh 2vw 2vh",
    background:
      "linear-gradient(180deg, rgba(255, 162, 162, 0.30) 0%, rgba(255, 255, 255, 0.00) 100%)",
  },
  headerContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "30px",
  },
  headerText: {
    fontSize: "24px",
    fontWeight: 600,
    color: "#111827",
    marginBottom: "4px",
  },
  idText: {
    fontSize: "12px",
    color: "#0D0D0E",
  },
  headerSubtext: {
    fontSize: "14px",
    color: "#6b7280",
  },
  tabsContainer: {
    marginBottom: "24px",
  },
  tabsNav: {
    display: "flex",
    gap: "8px",
  },
  tabButton: {
    padding: "10px 14px",
    borderRadius: "8px",
    fontSize: "12px",
    transition: "all 0.2s",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    border: "none",
    cursor: "pointer",
    fontFamily: "Inter Tight",
  },
  tabButtonActive: {
    backgroundColor: "#1f2937",
    color: "#ffffff",
  },
  tabButtonInactive: {
    backgroundColor: "#ffffff",
    color: "#6b7280",
    border: "1px solid #d1d5db",
    "&:hover": {
      backgroundColor: "#f9fafb",
      color: "#1f2937",
      borderColor: "#9ca3af",
    },
  },
  loadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "256px",
  },
  loadingText: {
    fontSize: "18px",
    color: "#6b7280",
  },
  errorContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "256px",
  },
  errorText: {
    color: "#dc2626",
  },
  activitiesContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  activitiesCard: {
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    border: "1px solid #e5e7eb",
    overflow: "hidden",
  },
  activityRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 24px",
    borderBottom: "1px solid #f3f4f6",
    "&:hover": {
      backgroundColor: "#f9fafb",
    },
    "&:last-child": {
      borderBottom: "none",
    },
  },
  activityNameContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    width: "20%",
  },
  activityName: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  activityNameText: {
    fontWeight: 500,
    color: "#111827",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  activityTypeContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    width: "16.67%",
    color: "#6b7280",
  },
  activityTypeText: {
    fontSize: "14px",
    fontWeight: 500,
  },
  dateContainer: {
    width: "20%",
    fontSize: "14px",
    color: "#6b7280",
  },
  dateLabel: {
    color: "#949daa",
    fontSize: "12px",
  },
  dateValue: {
    color: "#0d0d0e",
  },
  amountContainer: {
    width: "16.67%",
    fontSize: "14px",
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },
  amountLabel: {
    color: "#949daa",
  },
  amountValue: {
    color: "#0d0d0e",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  statusContainer: {
    fontSize: "14px",
    width: "14.29%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  statusIndicator: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  statusDot: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
  },
  dependenciesContainer: {
    width: "20%",
    fontSize: "14px",
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },
  dependenciesLabel: {
    color: "#949daa",
  },
  dependenciesValue: {
    color: "#0d0d0e",
    fontWeight: 500,
  },
  emptyState: {
    textAlign: "center",
    padding: "48px",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    border: "1px solid #e5e7eb",
  },
  emptyStateText: {
    color: "#6b7280",
  },
  milestoneTabContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    marginTop: "3vh",
  },
  milestoneGrid: {
    display: "grid",
    gridTemplateColumns: isMobile ? "1fr" : "repeat(2, 1fr)",
    gap: "24px",
  },
  milestoneCard: {
    backgroundColor: "#F9FAFB",
    borderRadius: "8px",
    padding: "16px",
  },
  milestoneCardTitle: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#111827",
    marginBottom: "16px",
  },
  activitiesList: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    maxHeight: "650px",
    overflowY: "auto",
  },
  activityItem: {
    padding: "1vh 1vw",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    cursor: "move",
    transition: "all 0.2s",
    backgroundColor: "#ffffff",
  },
  activityItemSelected: {
    borderColor: "#3b82f6",
    backgroundColor: "#eff6ff",
  },
  activityItemHover: {
    borderColor: "#d1d5db",
    "&:hover": {
      borderColor: "#9ca3af",
      backgroundColor: "#f9fafb",
    },
  },
  activityItemContent: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  activityItemCheckbox: {
    width: "16px",
    height: "16px",
    borderRadius: "4px",
    border: "1px solid #d1d5db",
    cursor: "pointer",
  },
  activityItemDetails: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    width: "100%",
  },
  activityItemInfo: {
    flex: 1,
    minWidth: 0,
  },
  activityItemHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  activityItemName: {
    fontWeight: 500,
    color: "#111827",
    fontSize: "14px",
  },
  activityItemDescription: {
    fontSize: "12px",
    color: "#6b7280",
    marginTop: "4px",
  },
  activityItemDates: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    fontSize: "12px",
    color: "#6b7280",
    whiteSpace: "nowrap",
  },
  emptyActivitiesText: {
    textAlign: "center",
    padding: "32px",
    color: "#6b7280",
    fontSize: "14px",
  },
  milestoneDropZone: {
    border: "2px dashed",
    borderRadius: "8px",
    padding: "16px",
    transition: "all 0.2s",
    backgroundColor: "#ffffff",
  },
  milestoneDropZoneActive: {
    borderColor: "#d1d5db",
    "&:hover": {
      borderColor: "#3b82f6",
    },
  },
  milestoneDropZoneRestricted: {
    borderColor: "#e5e7eb",
    backgroundColor: "#fff",
    cursor: "not-allowed",
    opacity: 0.7,
  },
  milestoneHeader: {
    marginBottom: "12px",
  },
  milestoneHeaderTop: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
  },
  milestoneName: {
    fontWeight: 600,
    color: "#111827",
  },
  milestoneMeta: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  milestoneDueDate: {
    fontSize: "12px",
    color: "#6b7280",
  },
  restrictedBadge: {
    fontSize: "12px",
    backgroundColor: "#e5e7eb",
    color: "#6b7280",
    padding: "4px 8px",
    borderRadius: "4px",
  },
  milestoneDescription: {
    fontSize: "14px",
    color: "#6b7280",
    marginTop: "4px",
  },
  milestoneInfo: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    marginTop: "8px",
    fontSize: "12px",
    color: "#6b7280",
  },
  milestoneInfoItem: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  linkedActivitiesSection: {
    marginTop: "12px",
    paddingTop: "12px",
    borderTop: "1px solid #e5e7eb",
  },
  linkedActivitiesLabel: {
    fontSize: "12px",
    color: "#6b7280",
    marginBottom: "8px",
  },
  linkedActivitiesList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  linkedActivityItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    backgroundColor: "#f9fafb",
    borderRadius: "4px",
    border: "1px solid #e5e7eb",
  },
  linkedActivityInfo: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flex: 1,
    minWidth: 0,
  },
  linkedActivityName: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#111827",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  removeButton: {
    color: "#dc2626",
    fontSize: "12px",
    padding: "4px 8px",
    borderRadius: "4px",
    border: "none",
    cursor: "pointer",
    boxShadow: "none",
    backgroundColor: "transparent",
    "&:hover": {
      color: "#991b1b",
      backgroundColor: "#fef2f2",
    },
    "&:disabled": {
      opacity: 0.5,
      cursor: "not-allowed",
    },
  },
  dropZonePlaceholder: {
    fontSize: "12px",
    color: "#9ca3af",
    textAlign: "center",
    padding: "16px",
  },
  emptyMilestonesText: {
    textAlign: "center",
    padding: "32px",
    color: "#6b7280",
    fontSize: "14px",
  },
});

export default styles;
